ipToLocation.$inject = ['$http', '$q']

export default function ipToLocation($http, $q) {
  return {
    // Consult https://ipapi.co/api/ for api docs
    getIpLocation: function(ip) {
      var deferred = $q.defer()
      var endpoint = `https://ipapi.co/${ip}/json`
      $http({
        method: 'GET',
        url: endpoint,
        withCredentials: false
      }).then(
        function(response) {
          if (response.data.reserved) {
            deferred.reject({
              ip: ip,
              message: 'Private IP'
            })
          } else if (response.data.error) {
            deferred.reject({
              ip: ip,
              message: response.data.reason
            })
          } else {
            deferred.resolve({
              ip: ip,
              location: `${response.data.city}, ${response.data.region}`
            })
          }
        },
        function(response) {
          // Per https://ipapi.co/api/#errors
          // Quota exceeded returns 429 and some extra messaging
          if (response.status == 429) {
            deferred.reject({
              ip: ip,
              message: `${response.data.reason}: ${response.data.message}`
            })
          } else {
            deferred.reject({
              ip: ip,
              message: `HTTP Error Code: ${response.status}`
            })
          }
        }
      )

      return deferred.promise
    }
  }
}
